// extracted by mini-css-extract-plugin
export default {"sponsors":"AllSponsors_sponsors__Swi8N"};